export default __webpack_public_path__ + "static/fire-pit-and-wood-stack-b8e4b7b2e6598edc8a771db052205c6a.jpg";